'use strict';

import _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';

export default class TileChoices extends React.Component {
	render() {
		return (
			<div className="TileChoices maxWidthContentWrapper">
				{_.map(this.props.children, child => {
					return React.cloneElement(child, {
						handleClick: this.props.handleClick.bind(null, child.props.id),
						key: child.props.id
					});
				})}
			</div>
		);
	}
}

TileChoices.propTypes = {
	children: PropTypes.node,
	handleClick: PropTypes.func.isRequired
};
